import {
  serviceBase,
  authorizations,
  createErrorMessage,
  createSuccessMessage
} from "../service";
import api from "../api";
const Users = {
  ...serviceBase,
  resource: "members",
  resourceRole: "user-groups",
  preList: function(params) {
    const projectId = extractProjectIdFromUrl() || "-";

    const id = params.project_id || projectId;
    delete params.id;
    return `user-groups/${id}`;
  },

  preListOption: {
    getList: true,
    deleteList: true
  },
  users: {
    get: function(params = {}, onSuccess = () => {}) {
      let { id, ...paramsWithOutId } = params;
      return api
        .get(`/user-groups/${id}/members`, paramsWithOutId)
        .then(res => {
          onSuccess(res.data.items);
        })
        .catch(res => createErrorMessage(res));
    },
    add: function(params = {}, onSuccess = () => {}) {
      let { id, email, ...paramsWithOutId } = params;
      return api
        .put(`/user-groups/${id}/members`, { email, ...paramsWithOutId })
        .then(() => {
          createSuccessMessage("add");
          onSuccess();
        })
        .catch(res => createErrorMessage(res));
    },
    delete: function(params = {}, onSuccess = () => {}) {
      let { id, member_id, ...paramsWithOutId } = params;
      return api
        .delete(`/user-groups/${id}/members/${member_id}`, paramsWithOutId)
        .then(() => {
          createSuccessMessage("delete");
          onSuccess();
        })
        .catch(res => createErrorMessage(res));
    }
  }
};
Users.authorizations = authorizations(Users);
export default Users;
function extractProjectIdFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("usergroup");
}
